import { createColumnHelper } from '@tanstack/react-table';

import { Status } from 'types/items';
import { convertUTCToLocal } from 'utils/dateUtils';

/**
 * `fetchPackages` (api/packages.ts) types its response as `FetchResponse<any>`,
 * so this shape is reconstructed here from the fields PackagesCreatedTable's
 * legacy CustomTable row actually read.
 */
export type PackageRow = {
  _id: string;
  createdAt: string | Date;
  status: number;
  packageSku?: { name?: string };
  caseSku?: { name?: string };
  items?: Array<{ quantity: number }>;
  site?: Array<{ name?: string }>;
};

const col = createColumnHelper<PackageRow>();

/** Sums each item's quantity; falls back to '-' when there are no items. */
export const totalItemsCount = (pkg: PackageRow) =>
  pkg?.items
    ?.map((i) => i.quantity)
    ?.reduce((acc, current) => acc + current, 0) || '-';

export const packagesCreatedColumns = [
  col.accessor((pkg) => pkg?._id || '-', {
    id: 'packageId',
    header: 'Package ID',
    minSize: 200,
    size: 320,
  }),
  col.accessor((pkg) => pkg?.packageSku?.name || '-', {
    id: 'packageSku',
    header: 'Package SKU',
    minSize: 200,
  }),
  col.accessor((pkg) => pkg?.caseSku?.name || '-', {
    id: 'caseSku',
    header: 'Case SKU',
    minSize: 150,
    meta: { align: 'center' },
  }),
  col.accessor((pkg) => totalItemsCount(pkg), {
    id: 'itemsCount',
    header: 'Items Count',
    minSize: 90,
    meta: { align: 'center' },
  }),
  col.accessor((pkg) => convertUTCToLocal(pkg?.createdAt, true), {
    id: 'createdAt',
    header: 'Created',
    minSize: 150,
    meta: { align: 'center' },
  }),
  col.accessor((pkg) => Status[pkg?.status] || '-', {
    id: 'status',
    header: 'Status',
    minSize: 110,
    meta: { align: 'center' },
  }),
  col.accessor((pkg) => pkg.site?.[0]?.name || '-', {
    id: 'site',
    header: 'Site',
    minSize: 150,
    meta: { align: 'center' },
  }),
];
